function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
import { getNavigationDimensions, getPositionForCentering, PLACEMENTS } from 'oskari-ui/components/window';
import './plugin/ToggleNavigation';
/**
 * @class Oskari.userinterface.bundle.ui.UserInterfaceBundleInstance
 *
 * Default DIV Manager implementation handles menu like and detached DIVs
 * handles hiding showing DIVS.
 * Draggability is enabled in top-border element when DIV is detached
 *
 */
Oskari.clazz.define('Oskari.userinterface.bundle.ui.UserInterfaceBundleInstance',
/**
 * @method init called on constructing this instance
 */

function () {
  this.sandbox = null;

  /**
   * @property requestHandlers
   */
  this.requestHandlers = {};
  this.extensions = [];
  this.extensionsByName = {};

  /**
   * @property compiledTemplates
   *
   * HTML templates 'compiled' with jQuery - HTML code in static property templates
   */
  this.compiledTemplates = {};

  /**
   * @property flyoutContainer (document.body)
   */
  this.flyoutContainer = null;

  /**
   * @property tileContainer (#menubar)
   */
  this.tileContainer = null;

  /**
   * @property flyoutZIndexBase
   */
  this.flyoutZIndexBase = 20000;

  /**
   * @property menubarContainerId
   */
  this.menubarContainerId = '#menubar';
}, {
  getName: function getName() {
    return 'userinterface.DivManazer';
  },
  init: function init(sandbox) {},
  getExtensionByName: function getExtensionByName(name) {
    return this.extensionsByName[name];
  },
  /**
   * @method getSandbox
   */
  getSandbox: function getSandbox() {
    return this.sandbox;
  },
  /**
   * @method start
   *
   * implements BundleInstance start methdod
   *
   * creates tile and flyout compiledTemplates
   * creates and registers request handlers
   *
   */
  start: function start() {
    /*
     * setup templates
     */
    this.compileTemplates();

    /*
     * setup requests and handlers
     */
    var me = this,
      conf = me.conf,
      sandboxName = (conf ? conf.sandbox : null) || 'sandbox',
      sandbox = Oskari.getSandbox(sandboxName);
    me.sandbox = sandbox;

    // me.flyoutContainer = jQuery(document.body);
    me.flyoutContainer = jQuery(Oskari.dom.getRootEl());
    me.tileContainer = jQuery(me.menubarContainerId);
    me.tileContainer.addClass('oskari-tile-container');
    me.sandbox.register(me);
    me.requestHandlers.add = Oskari.clazz.create('Oskari.userinterface.bundle.ui.request.AddExtensionRequestHandler', me);
    me.requestHandlers.remove = Oskari.clazz.create('Oskari.userinterface.bundle.ui.request.RemoveExtensionRequestHandler', me);
    me.requestHandlers.update = Oskari.clazz.create('Oskari.userinterface.bundle.ui.request.UpdateExtensionRequestHandler', me);
    sandbox.requestHandler('userinterface.AddExtensionRequest', me.requestHandlers.add);
    sandbox.requestHandler('userinterface.RemoveExtensionRequest', me.requestHandlers.remove);
    sandbox.requestHandler('userinterface.UpdateExtensionRequest', me.requestHandlers.update);
    me.requestHandlers.modal = Oskari.clazz.create('Oskari.userinterface.bundle.ui.request.ModalDialogRequestHandler', me);
    sandbox.requestHandler('userinterface.ModalDialogRequest', me.requestHandlers.modal);
    this.eventHandlers = this._createEventHandlers();
    for (var p in this.eventHandlers) {
      if (this.eventHandlers.hasOwnProperty(p)) {
        sandbox.registerForEventByName(me, p);
      }
    }

    // Hide navigation if starts in mobile mode
    var nav = Oskari.dom.getNavigationEl();
    if (nav) {
      Oskari.dom.showNavigation(!Oskari.util.isMobile());
      var mapModule = this.sandbox.findRegisteredModuleInstance('MainMapModule');
      var ToggleNavigationPlugin = Oskari.clazz.create('Oskari.userinterface.plugin.ToggleNavigationPlugin');
      mapModule.registerPlugin(ToggleNavigationPlugin);
      mapModule.startPlugin(ToggleNavigationPlugin);
    }
    Oskari.on('app.start', function () {
      Oskari.dom.setMenuScrollIndicator();
    });

    /* removed for some reason or another */
    // sandbox.registerAsStateful(me.mediator.bundleId, me);
  },
  /**
   * @method update
   *
   * implements bundle instance update method
   */
  update: function update() {},
  /**
   * @method stop
   * implements bundle instance stop method
   * removes request handlers
   */
  stop: function stop() {
    this.sandbox.requestHandler('userinterface.UpdateExtensionRequest', null);
    this.sandbox.removeRequestHandler('userinterface.RemoveExtensionRequest', this.requestHandlers.remove);
    this.sandbox.removeRequestHandler('userinterface.AddExtensionRequest', this.requestHandlers.add);
    this.sandbox.removeRequestHandler('userinterface.ModalDialogRequest', this.requestHandlers.modal);

    // this.sandbox.unregisterStateful(this.mediator.bundleId);
    for (var p in this.eventHandlers) {
      if (this.eventHandlers.hasOwnProperty(p)) {
        this.sandbox.unregisterFromEventByName(this, p);
      }
    }
    this.sandbox.unregister(this);
    this.started = false;
  },
  // TODO: rename "getDefaultFlyoutPosition()"?
  getMapdivOffset: function getMapdivOffset(el) {
    var dimensions = getNavigationDimensions();
    var left = 30;
    var top = 30;
    if (dimensions.placement === PLACEMENTS.LEFT) {
      // menu on left side -> make flyouts open next to it
      left = dimensions.width;
    } else if (dimensions.placement === PLACEMENTS.TOP) {
      // menu on top -> make flyouts open under
      top = dimensions.height;
    } else if (el) {
      // flyouts usually don't have their content rendered when this is called, so it doesn't really work :(
      var _getPositionForCenter = getPositionForCentering(el),
        x = _getPositionForCenter.x,
        y = _getPositionForCenter.y;
      top = y;
      left = x;
    }
    return {
      top: top,
      left: left
    };
  },
  /**
   * HTML templates
   */
  templates: {
    /* menu tile */
    'Oskari.userinterface.Tile': '<div class="oskari-tile oskari-tile-closed">' + '    <div class="oskari-tile-title"></div>' + '    <div class="oskari-tile-status"></div>' + '</div>',
    /* view */
    'Oskari.userinterface.View': '<div class="oskari-view"></div>'
  },
  /**
   * @method compileTemplates
   *
   * creates jQuery template to be cloned to any menubar Tiles
   */
  compileTemplates: function compileTemplates() {
    /**
     * Templates
     */
    var me = this;
    me.compiledTemplates['Oskari.userinterface.Tile'] = jQuery(me.templates['Oskari.userinterface.Tile']);
    me.compiledTemplates['Oskari.userinterface.View'] = jQuery(me.templates['Oskari.userinterface.View']);
  },
  /**
   * @method addExtension
   *
   * adds extension to Oskari DIV Manager in response to a
   * AddExtensionRequest
   */
  addExtension: function addExtension(extension) {
    var me = this,
      plugins,
      extensions,
      extensionsByName,
      extensionInfo,
      count,
      name,
      flyoutPlugin,
      el,
      tilePlugin,
      tile,
      viewPlugin,
      view;
    extension.startExtension();
    plugins = extension.getPlugins();
    extensions = me.extensions;
    extensionsByName = me.extensionsByName;
    extensionInfo = {
      state: 'close',
      extension: extension,
      draggable: null,
      draggableTarget: null,
      draggableHandle: null,
      viewState: {},
      extensionUpdatedEvent: null,
      plugins: {}
    };
    extensionInfo.extensionUpdatedEvent = Oskari.eventBuilder('userinterface.ExtensionUpdatedEvent')(extension, extensionInfo.state);
    count = extensions.length;
    name = extension.getName();
    flyoutPlugin = plugins['Oskari.userinterface.Flyout'];
    if (flyoutPlugin !== null && flyoutPlugin !== undefined) {
      var flyout = me.createFlyout(extension, flyoutPlugin, count, extensionInfo);
      var flyoutElem = flyout.getElement();
      var contentElem = flyout.getContent();
      flyoutPlugin.setEl(contentElem.get(), flyoutElem);
      me.flyoutContainer.append(flyoutElem);
      flyoutPlugin.startPlugin();
      extensionInfo.plugins['Oskari.userinterface.Flyout'] = {
        plugin: flyoutPlugin,
        flyout: flyout,
        el: flyoutElem
      };
    }
    tilePlugin = plugins['Oskari.userinterface.Tile'];
    tile = null;
    if (tilePlugin !== null && tilePlugin !== undefined) {
      tile = me.createTile(extension, tilePlugin, count, extensionInfo);
      tilePlugin.startPlugin();
      tile.fadeIn(200);
      me.tileContainer.append(tile);
    }
    viewPlugin = plugins['Oskari.userinterface.View'];
    view = null;
    if (viewPlugin !== null && viewPlugin !== undefined) {
      view = me.createView(extension, viewPlugin, count, extensionInfo);
      el = view;
      viewPlugin.setEl(el.get());
      viewPlugin.startPlugin();
    }

    /*
     * store these for further usage
     */

    if (tilePlugin) {
      extensionInfo.plugins['Oskari.userinterface.Tile'] = {
        plugin: tilePlugin,
        el: tile
      };
    }
    if (viewPlugin) {
      extensionInfo.plugins['Oskari.userinterface.View'] = {
        plugin: viewPlugin,
        el: view
      };
    }
    extensions.push(extensionInfo);
    extensionsByName[name] = extensionInfo;
    return extensionInfo;
  },
  /**
   * @method _applyDraggableToFlyout
   * applies draggable handle to flyouts title bar
   */
  _applyDraggableToFlyout: function _applyDraggableToFlyout(flyout, extensionInfo, cls) {
    var me = this;
    var handle = flyout.children(cls).get()[0];
    var flyoutTarget = flyout.get()[0];
    var useHelper = false;
    var el;
    var helperFn;
    if (useHelper) {
      // note! useHelper is always false
      // not sure why this is here...
      helperFn = function helperFn() {
        el = jQuery('<div />');
        el.css('width', flyout.css('width'));
        el.css('height', flyout.css('height'));
        el.css('border', '2px solid rgba(0,0,0,.5)');
        el.css('z-index', flyout.css('z-index'));
        return el;
      };
    }
    extensionInfo.draggableHandle = handle;
    extensionInfo.draggableTarget = flyoutTarget;
    extensionInfo.draggable = jQuery(flyout).draggable({
      handle: jQuery(handle),
      helper: useHelper ? helperFn : null,
      scroll: false,
      stack: '.oskari-flyout',
      create: function create(event, ui) {},
      start: function start() {
        if (useHelper) {
          flyout.css('display', 'none');
        }
      },
      drag: function drag() {},
      stop: function stop(event, ui) {
        var viewState;
        if (useHelper) {
          flyout.css('top', ui.helper.css('top'));
          flyout.css('left', ui.helper.css('left'));
        }
        me.shuffleZIndices(flyout);
        if (useHelper) {
          flyout.css('display', '');
        }
        viewState = me.getFlyoutViewState(flyout, 'detach');
        extensionInfo.viewState = viewState;
        me.notifyExtensionViewStateChange(extensionInfo);
      }
    });
  },
  /**
   * @method createTile
   *
   * creates menubar tile using the tile template
   */
  createTile: function createTile(extension, plugin, count, extensionInfo) {
    var me = this,
      // container = jQuery('#menubar'),
      tile = this.compiledTemplates['Oskari.userinterface.Tile'].clone(true, true),
      tilePlugin = extension.plugins['Oskari.userinterface.Tile'],
      title = tile.children('.oskari-tile-title'),
      _tileClick = function tileClick() {
        // plugin.setExtensionState();
        tile.off('click');
        if (tilePlugin.clickHandler) {
          tilePlugin.clickHandler(extensionInfo.state);
        } else {
          me.getSandbox().postRequestByName('userinterface.UpdateExtensionRequest', [extension, 'toggle']);
        }
        window.setTimeout(function () {
          tile.on('click', _tileClick);
        }, 500);
      };
    // status;
    title.append(plugin.getTitle());
    // status = tile.children('.oskari-tile-status');

    tile.on('click', _tileClick);
    plugin.setEl(tile.get());
    return tile;
  },
  /**
   * @method createFlyout
   *
   * creates flyout DIV using the ExtraFlyout extension
   * adds a bunch of tools to the DIV toolbar, sets default position and makes flyout draggable
   *
   */
  createFlyout: function createFlyout(extension, plugin, count, extensionInfo) {
    var me = this;
    var _this$getFlyoutDefaul = this.getFlyoutDefaultPositions().attach,
      top = _this$getFlyoutDefaul.top,
      left = _this$getFlyoutDefaul.left;
    var flyoutOpts = {
      container: this.flyoutContainer,
      isExtension: true,
      top: parseInt(top),
      left: parseInt(left)
    };
    var flyout = Oskari.clazz.create('Oskari.userinterface.extension.ExtraFlyout', plugin.getTitle(), flyoutOpts);
    var elem = flyout.getElement();
    /*
    // try to adjust position if nav is not on left
    // problem: content isn't rendered so placement is off at this point -> commented out for now
    const newCoords = this.getFlyoutDefaultPositions(elem[0]).attach;
    flyout.move(newCoords.left, newCoords.top);
    */

    var toolage = {
      attach: elem.find('.oskari-flyouttool-attach'),
      detach: elem.find('.oskari-flyouttool-detach'),
      minimize: elem.find('.oskari-flyouttool-minimize'),
      restore: elem.find('.oskari-flyouttool-restore'),
      close: elem.find('.oskari-flyouttool-close'),
      help: elem.find('.oskari-flyouttool-help')
    };
    toolage.detach.on('click', function () {
      me.getSandbox().postRequestByName('userinterface.UpdateExtensionRequest', [extension, 'detach']);
    });
    toolage.attach.on('click', function () {
      me.getSandbox().postRequestByName('userinterface.UpdateExtensionRequest', [extension, 'attach']);
    });
    toolage.minimize.on('click', function () {
      me.getSandbox().postRequestByName('userinterface.UpdateExtensionRequest', [extension, 'minimize']);
    });
    toolage.restore.on('click', function () {
      me.getSandbox().postRequestByName('userinterface.UpdateExtensionRequest', [extension, 'restore']);
    });
    toolage.close.on('click', function () {
      me.getSandbox().postRequestByName('userinterface.UpdateExtensionRequest', [extension, 'close']);
    });
    toolage.help.on('click', function () {
      me.getSandbox().postRequestByName('userguide.ShowUserGuideRequest', [{
        placement: 'bottom',
        el: toolage.help,
        extension: extension.getName(),
        toggle: true
      }]);
    });
    return flyout;
  },
  /**
   * @method createFlyout
   *
   * creates flyout DIV using the flyout template adds a bunch
   * of tools to the DIV toolbar
   *
   */
  createView: function createView(extension, plugin, count, extensionInfo) {
    var me = this,
      view = me.compiledTemplates['Oskari.userinterface.View'].clone(true, true);
    return view;
  },
  /**
   * @method removeExtension TBD
   */
  removeExtension: function removeExtension(extension) {
    /*
     * to-do:
     * - remove tile
     * - remove flyout
     */

    var me = this,
      extensions = me.extensions,
      extensionsByName = this.extensionsByName,
      extensionInfo = extensionsByName[extension.getName()],
      // extensionState = extensionInfo.state,
      flyoutInfo = extensionInfo.plugins['Oskari.userinterface.Flyout'],
      flyoutPlugin,
      flyout,
      ops,
      closeOp,
      tileInfo,
      // tilePlugin,
      tile,
      after,
      n,
      len;
    if (flyoutInfo) {
      flyoutPlugin = flyoutInfo.plugin;
      flyout = flyoutInfo.el;
      ops = this.flyoutOps;
      closeOp = ops.close;
      closeOp.apply(this, [flyout, flyoutPlugin, extensionInfo]);
      flyout.remove();
    }
    tileInfo = extensionInfo.plugins['Oskari.userinterface.Tile'];
    if (tileInfo) {
      // tilePlugin = tileInfo.plugin;
      tile = tileInfo.el;
      tile.remove();
    }
    extensionsByName[extension.getName()] = null;
    after = [];
    for (n = 0, len = extensions.length; n < len; n += 1) {
      if (extensions[n] !== extensionInfo) {
        after.push(extensions[n]);
      }
    }
    me.extensions = after;
    extension.stopExtension();
  },
  /**
   * @method updateExtension updates extension state
   *
   */
  updateExtension: function updateExtension(extension, request) {
    var me = this,
      extensions = me.extensions,
      i,
      extensionsByName,
      extensionInfo,
      extensionState,
      state,
      ops,
      op,
      flyoutInfo,
      closeOp,
      n,
      otherExtensionInfo,
      otherState,
      plgnfo,
      otherFlyoutInfo,
      otherFlyoutPlugin,
      otherFlyout,
      otherTileInfo,
      otherTile,
      flyoutPlugin,
      flyout,
      tileInfo,
      tile,
      viewInfo,
      viewPlugin,
      view,
      len;
    if (!extension) {
      // if extension not spesified, do it for all
      for (i = 0; i < extensions.length; i += 1) {
        this.updateExtension(extensions[i].extension, request);
      }
      return;
    }
    extensionsByName = this.extensionsByName;
    extensionInfo = extensionsByName[extension.getName()];
    if (!extensionInfo) {
      // tried to control non-existing extension
      return;
    }
    extensionState = extensionInfo.state;
    state = request.getState();
    if (state === 'toggle') {
      if (extensionState === 'close') {
        state = 'attach';
      } else if (extensionState === 'attach') {
        state = 'close';
      } else if (extensionState === 'detach') {
        state = 'minimize';
      } else if (extensionState === 'minimize') {
        state = 'restore';
      } else if (extensionState === 'restore') {
        state = 'minimize';
      } else if (extensionState === 'hide') {
        state = 'attach';
      }
    }
    flyoutInfo = extensionInfo.plugins['Oskari.userinterface.Flyout'];

    /* opening extension 'attached' closes previously attachily opened extensions (tile, flyout) */
    if (state === 'attach') {
      ops = me.flyoutOps;
      closeOp = ops.close;
      for (n = 0, len = extensions.length; n < len; n += 1) {
        otherExtensionInfo = extensions[n];
        if (otherExtensionInfo === extensionInfo) {
          continue;
        }
        if (otherExtensionInfo.state !== 'attach' && otherExtensionInfo.state !== 'hide') {
          continue;
        }
        otherState = 'close';
        plgnfo = otherExtensionInfo.plugins;
        otherFlyoutInfo = plgnfo['Oskari.userinterface.Flyout'];
        if (otherFlyoutInfo) {
          otherFlyoutPlugin = otherFlyoutInfo.plugin;
          otherFlyout = otherFlyoutInfo.el;
          closeOp.apply(this, [otherFlyout, otherFlyoutPlugin, otherExtensionInfo]);
        }
        otherTileInfo = plgnfo['Oskari.userinterface.Tile'];
        if (otherTileInfo) {
          otherTile = otherTileInfo.el;
          me.applyTransition(otherTile, otherState, me.tileTransitions);
        }
        otherExtensionInfo.state = otherState;
        me.notifyExtensionViewStateChange(otherExtensionInfo);
      }
    }
    var extLocation = function extLocation(request, me, axis) {
      if (request.getExtensionLocation().top || request.getExtensionLocation().left) {
        me.origExtensionLocation = {};
      }
      if (me.origExtensionLocation) {
        if (request.getExtensionLocation()[axis]) {
          me.origExtensionLocation[axis] = jQuery(flyoutInfo.el).css(axis);
          jQuery(flyoutInfo.el).css(axis, request.getExtensionLocation()[axis] + 'px');
        } else if (me.origExtensionLocation[axis]) {
          jQuery(flyoutInfo.el).css(axis, me.origExtensionLocation[axis]);
        }
      }
    };

    /* let's transition flyout if one exists */
    if (flyoutInfo) {
      flyoutPlugin = flyoutInfo.plugin;
      flyout = flyoutInfo.el;
      if (state === 'attach') {
        extLocation(request, me, 'top');
        extLocation(request, me, 'left');
        // if flyout plugin has a lazyRender created, use it.
        if (flyoutPlugin.lazyRender) {
          flyoutPlugin.lazyRender();
        }
      }

      /**
       * do the op for this extension
       */
      ops = me.flyoutOps;
      op = ops[state];
      op.apply(this, [flyout, flyoutPlugin, extensionInfo, extensions]);
    }

    /* let's transition menu tile if one exists */
    tileInfo = extensionInfo.plugins['Oskari.userinterface.Tile'];
    if (tileInfo) {
      tile = tileInfo.el;
      me.applyTransition(tile, state, me.tileTransitions);
    }

    /* let's transition menu tile if one exists */
    viewInfo = extensionInfo.plugins['Oskari.userinterface.View'];
    if (viewInfo) {
      viewPlugin = viewInfo.plugin;
      view = viewInfo.el;
      ops = me.viewOps;
      op = ops[state];
      if (op) {
        op.apply(this, [view, viewPlugin, extensionInfo, extensions]);
      }
    }
    extensionInfo.state = state;
    me.notifyExtensionViewStateChange(extensionInfo);
  },
  /**
   * @method notifyExtensionViewStateChange
   */
  notifyExtensionViewStateChange: function notifyExtensionViewStateChange(extensionInfo) {
    var evt = extensionInfo.extensionUpdatedEvent;
    evt.setViewState(extensionInfo.state);
    evt.setViewInfo(extensionInfo.viewState);
    this.sandbox.notifyAll(evt, true);
  },
  getFlyoutDefaultPositions: function getFlyoutDefaultPositions(el) {
    var _this$getMapdivOffset = this.getMapdivOffset(el),
      left = _this$getMapdivOffset.left,
      top = _this$getMapdivOffset.top;
    return {
      detach: {
        left: '212px',
        top: '50px'
      },
      attach: {
        left: left,
        top: top
      }
    };
  },
  /*
   * @static @property validStates
   */
  validStates: {
    attach: {
      attach: true,
      detach: false,
      close: false,
      minimize: false,
      restore: false,
      drawer: false,
      sidebar: false
    },
    detach: {
      attach: false,
      detach: true,
      close: false,
      minimize: false,
      restore: false,
      drawer: false,
      sidebar: false
    },
    minimize: {
      attach: true,
      detach: true,
      close: false,
      minimize: true,
      restore: false,
      drawer: false,
      sidebar: false
    },
    restore: {
      attach: false,
      detach: true,
      close: false,
      minimize: false,
      restore: true,
      drawer: false,
      sidebar: false
    },
    close: {
      attach: false,
      detach: false,
      close: true,
      minimize: false,
      restore: false,
      drawer: false,
      sidebar: false
    },
    drawer: {
      attach: false,
      detach: false,
      close: false,
      minimize: false,
      restore: false,
      drawer: true,
      sidebar: false
    },
    sidebar: {
      attach: false,
      detach: false,
      close: false,
      minimize: false,
      restore: false,
      drawer: false,
      sidebar: true
    }
  },
  /**
   * @static @property tileTransitions
   * CSS transitions for menu tiles
   */
  tileTransitions: {
    attach: {
      'oskari-tile-attached': true,
      'oskari-tile-detached': false,
      'oskari-tile-closed': false
    },
    detach: {
      'oskari-tile-attached': false,
      'oskari-tile-detached': true,
      'oskari-tile-minimized': false,
      'oskari-tile-closed': false
    },
    minimize: {
      'oskari-tile-minimized': true,
      'oskari-tile-closed': false,
      'oskari-tile-detached': false
    },
    restore: {
      'oskari-tile-minimized': false,
      'oskari-tile-detached': true
    },
    close: {
      'oskari-tile-closed': true,
      'oskari-tile-attached': false,
      'oskari-tile-detached': false
    }
  },
  /**
   * @static @property flyoutTransitions
   * CSS transitions for flyouts
   */
  flyoutTransitions: {
    attach: {
      'oskari-attached': true,
      'oskari-detached': false,
      'oskari-closed': false,
      'oskari-hidden': false
    },
    detach: {
      'oskari-attached': false,
      'oskari-detached': true,
      'oskari-closed': false
    },
    minimize: {
      'oskari-minimized': true,
      'oskari-closed': false,
      'oskari-detached': false
    },
    restore: {
      'oskari-minimized': false,
      'oskari-closed': false,
      'oskari-detached': true,
      'oskari-attached': false
    },
    close: {
      'oskari-closed': true,
      'oskari-minimized': false,
      'oskari-detached': false,
      'oskari-attached': false,
      'oskari-hidden': false
    },
    hide: {
      'oskari-attached': true,
      'oskari-detached': false,
      'oskari-closed': false,
      'oskari-hidden': true
    }
  },
  /**
   * @method applyTransition
   * adds and removes CSS classes from element
   *
   */
  applyTransition: function applyTransition(obj, state, transitions) {
    var transition = transitions[state],
      t;
    if (!transition) {
      return;
    }
    for (t in transition) {
      if (transition.hasOwnProperty(t)) {
        if (transition[t]) {
          obj.addClass(t);
        } else {
          obj.removeClass(t);
        }
      }
    }
  },
  /**
   * @method getFlyoutViewState
   *
   */
  getFlyoutViewState: function getFlyoutViewState(flyout, state) {
    var viewState = {
      left: flyout.css('left'),
      top: flyout.css('top'),
      width: flyout.width(),
      height: flyout.height(),
      'z-index': flyout.css('z-index'),
      viewState: state
    };
    return viewState;
  },
  /**
   * @static @property flyoutOps a set of (jQuery) operations to be
   *           performed on flyout to
   *           show/hide/minimize/restore/attach/detach
   */
  flyoutOps: {
    /** @method detach */
    detach: function detach(el, flyoutPlugin, extensionInfo, extensions) {
      var flyout = extensionInfo.plugins['Oskari.userinterface.Flyout'].flyout;
      flyout.bringToTop();
      var _extensionInfo$viewSt = extensionInfo.viewState,
        left = _extensionInfo$viewSt.left,
        top = _extensionInfo$viewSt.top;
      var _this$getFlyoutDefaul2 = this.getFlyoutDefaultPositions(flyout.getEl && flyout.getEl()),
        attach = _this$getFlyoutDefaul2.attach,
        detach = _this$getFlyoutDefaul2.detach;
      if (!left || !top || left === attach.left && top === attach.top) {
        flyout.move(parseInt(detach.left), parseInt(detach.top));
      }

      /*
       * with style
       */
      this.applyTransition(el, 'detach', this.flyoutTransitions);
      extensionInfo.viewState = this.getFlyoutViewState(el, 'detach');
    },
    /** @method attach */
    attach: function attach(el, flyoutPlugin, extensionInfo, extensions) {
      var flyout = extensionInfo.plugins['Oskari.userinterface.Flyout'].flyout;
      flyout.bringToTop();
      /*
       * with style
       */
      this.applyTransition(el, 'attach', this.flyoutTransitions);
      extensionInfo.viewState = this.getFlyoutViewState(el, 'attach');
      if (flyoutPlugin.onOpen) {
        flyoutPlugin.onOpen();
      }
    },
    /** @method minimize */
    minimize: function minimize(el, flyoutPlugin, extensionInfo) {
      this.applyTransition(el, 'minimize', this.flyoutTransitions);
      extensionInfo.viewState = this.getFlyoutViewState(el, 'minimize');
    },
    /** @method restore */
    restore: function restore(el, flyoutPlugin, extensionInfo) {
      var flyout = extensionInfo.plugins['Oskari.userinterface.Flyout'].flyout;
      flyout.bringToTop();
      this.applyTransition(el, 'restore', this.flyoutTransitions);
    },
    /** @method close */
    close: function close(el, flyoutPlugin, extensionInfo) {
      extensionInfo.viewState = {
        viewState: 'close'
      };
      this.applyTransition(el, 'close', this.flyoutTransitions);
      if (flyoutPlugin.onClose) {
        flyoutPlugin.onClose();
      }
    },
    /**
     * @method hide
     * Only attached flyout can be set hidden
     */
    hide: function hide(el, flyoutPlugin, extensionInfo) {
      if (extensionInfo.viewState.viewState !== 'attach') {
        return;
      }
      this.applyTransition(el, 'hide', this.flyoutTransitions);
      extensionInfo.viewState = this.getFlyoutViewState(el, 'hide');
    }
  },
  /**
   * @static
   * @property flyoutOps a set of (jQuery) operations to be
   *           performed on flyout to
   *           show/hide/minimize/restore/attach/detach
   */
  viewOps: {
    /** @method detach */
    view: function view(flyout, flyoutPlugin, extensionInfo, extensions) {},
    /** @method close */
    close: function close(flyout, flyoutPlugin, extensionInfo) {}
  },
  /**
   * @method setState
   *
   * restores state from state snapshot
   *
   * @param {Object} state bundle state as JSON
   */
  setState: function setState(state) {
    var me = this,
      divmanazerState = state,
      e,
      extensionInfo,
      restoredState;
    if (!divmanazerState) {
      return;
    }
    for (e in me.extensionsByName) {
      if (me.extensionsByName.hasOwnProperty(e)) {
        extensionInfo = me.extensionsByName[e];
        restoredState = divmanazerState.extensionStatesByName[e];
        if (restoredState) {
          extensionInfo.state = restoredState.state;
          extensionInfo.viewState = restoredState.viewState || {};
        }
      }
    }

    /* let's not Bundles may not have been loaded */
    /* me.restoreExtensionViewStates(); */
  },
  /**
   * @method getState
   *
   * builds a state snapshot
   *
   * @return {Object} bundle state as JSON
   */
  getState: function getState() {
    var me = this,
      divmanazerState,
      e,
      extensionInfo;
    me.refreshExtensionViewStates();
    divmanazerState = {
      extensionStatesByName: {}
    };
    for (e in me.extensionsByName) {
      if (me.extensionsByName.hasOwnProperty(e)) {
        extensionInfo = me.extensionsByName[e];
        divmanazerState.extensionStatesByName[e] = {
          state: extensionInfo.state,
          viewState: extensionInfo.viewState
        };
      }
    }
    return divmanazerState;
  },
  /**
   * @method applyState
   *
   * called after all bundles go will restore view states
   *
   */
  applyState: function applyState() {
    var me = this;
    me.restoreExtensionViewStates();
  },
  /**
   * @method refreshExtensionStates
   * moves state to cache
   */
  refreshExtensionViewStates: function refreshExtensionViewStates() {
    var me = this,
      e,
      extensionInfo,
      flyoutInfo,
      // flyoutPlugin,
      flyout,
      viewState;
    for (e in me.extensionsByName) {
      if (me.extensionsByName.hasOwnProperty(e)) {
        extensionInfo = me.extensionsByName[e];
        flyoutInfo = extensionInfo.plugins['Oskari.userinterface.Flyout'];
        if (flyoutInfo) {
          // flyoutPlugin = flyoutInfo.plugin;
          flyout = flyoutInfo.el;
          viewState = me.getFlyoutViewState(flyout, extensionInfo.state);
          extensionInfo.viewState = viewState;
        }
      }
    }
  },
  /**
   * @method restoreExtensionViewStates
   */
  restoreExtensionViewStates: function restoreExtensionViewStates() {
    var me = this,
      ops = me.flyoutOps,
      extensions = me.extensions,
      e,
      extensionInfo,
      // extension,
      flyoutInfo,
      flyoutPlugin,
      flyout,
      viewState,
      op,
      tileInfo,
      // tilePlugin,
      tile;
    for (e in me.extensionsByName) {
      if (me.extensionsByName.hasOwnProperty(e)) {
        extensionInfo = me.extensionsByName[e];
        // extension = extensionInfo.extension;

        flyoutInfo = extensionInfo.plugins['Oskari.userinterface.Flyout'];
        if (flyoutInfo) {
          flyoutPlugin = flyoutInfo.plugin;
          flyout = flyoutInfo.el;
          viewState = extensionInfo.viewState;
          flyout.removeAttr('style');
          flyout.css('left', viewState.left);
          flyout.css('top', viewState.top);
          flyout.width(viewState.width);
          flyout.height(viewState.height);
          flyout.css('z-index', viewState['z-index']);
          op = ops[extensionInfo.state];
          /* me.getSandbox().postRequestByName('userinterface.UpdateExtensionRequest', [extension, viewState]); */
          op.apply(me, [flyout, flyoutPlugin, extensionInfo, extensions]);
        }
        tileInfo = extensionInfo.plugins['Oskari.userinterface.Tile'];
        if (tileInfo) {
          // tilePlugin = tileInfo.plugin;
          tile = tileInfo.el;
          me.applyTransition(tile, extensionInfo.state, me.tileTransitions);
        }
      }
    }
  },
  /**
   *
   * @method shuffleZIndexes
   *
   * called after dragStop (or updateExtension) to restore some reasonable z-indexes
   * as well as bump the requested flyout on top of others
   *
   */
  shuffleZIndices: function shuffleZIndices(toTop) {
    var me = this,
      // extensions = me.extensions,
      zarray = [],
      zprops = {},
      zextns = {},
      zflyout = {},
      min = this.flyoutZIndexBase,
      idx,
      e,
      extensionInfo,
      // extension,
      flyoutInfo,
      // flyoutPlugin,
      flyout,
      zIndex,
      n;
    for (e in me.extensionsByName) {
      if (me.extensionsByName.hasOwnProperty(e)) {
        extensionInfo = me.extensionsByName[e];
        // extension = extensionInfo.extension;
        flyoutInfo = extensionInfo.plugins['Oskari.userinterface.Flyout'];
        if (flyoutInfo) {
          // flyoutPlugin = flyoutInfo.plugin;
          flyout = flyoutInfo.el;
          zIndex = flyout.css('z-index');
          zarray.push(zIndex);
          idx = String(zIndex);
          zprops[idx] = zIndex;
          zflyout[idx] = flyout;
          zextns[idx] = extensionInfo;
        }
      }
    }
    zarray.sort();
    for (n = 0; n < zarray.length; n += 1) {
      idx = zarray[n];
      zprops[idx] = min + n;
      zflyout[idx].css('z-index', zprops[zarray[n]]);
    }

    /*
     * finally bump the requested flyout to top
     */
    toTop.css('z-index', min + zarray.length + 2);
  },
  /**
   * @method onEvent
   * @param {Oskari.mapframework.event.Event} event a Oskari event
   * object
   * Event is handled forwarded to correct #eventHandlers if found
   * or discarded if not.
   */
  onEvent: function onEvent(event) {
    var handler = this.eventHandlers[event.getName()];
    if (!handler) {
      return;
    }
    return handler.apply(this, [event]);
  },
  /**
   * @method _createEventHandlers
   * Create eventhandlers.
   *
   *
   * @return {Object.<string, Function>} EventHandlers
   */
  _createEventHandlers: function _createEventHandlers() {
    return {
      MapSizeChangedEvent: function MapSizeChangedEvent(evt) {
        Oskari.dom.setMenuScrollIndicator();
      }
    };
  },
  ieFixClasses: [{
    min: 400,
    max: 599,
    cls: 'oskari-flyoutcontentcontainer_IE_400_599'
  }, {
    min: 600,
    max: 799,
    cls: 'oskari-flyoutcontentcontainer_IE_600_799'
  }, {
    min: 800,
    max: 999,
    cls: 'oskari-flyoutcontentcontainer_IE_800_999'
  }, {
    min: 1000,
    max: 1199,
    cls: 'oskari-flyoutcontentcontainer_IE_1000_1199'
  }, {
    min: 1200,
    max: 1399,
    cls: 'oskari-flyoutcontentcontainer_IE_1200_1399'
  }, {
    min: 1400,
    max: 9999,
    cls: 'oskari-flyoutcontentcontainer_IE_1400'
  }]
}, {
  protocol: ['Oskari.bundle.BundleInstance', 'Oskari.mapframework.module.Module', 'Oskari.userinterface.Stateful']
});